// Added by Jonghyung Lee on 2020-11-04
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios from 'axios'

import { getQueryString } from '@/helper/util'
import { GetQueryReturn } from '@/helper/define'
import { WPSWorks } from '@/helper/define/wpsDefine'
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const reqGetWPSWorks = async (query?: any) => {
  const queryStr = getQueryString<any>(query)
  return await axios.get<GetQueryReturn<WPSWorks>>(`/v1/mgmt/wps/work-items${queryStr}`)
}

export const reqGetWPSWork = async (id: string) => {
  return await axios.get<WPSWorks>(`/v1/mgmt/wps/work-items/${id}`)
}

export const reqCreateWPSWorks = async (elements: WPSWorks) => {
  return await axios.post<WPSWorks>(`/v1/mgmt/wps/work-items`, { ...elements })
}

export const reqUpdateWPSWorks = async (id: string, elements: WPSWorks) => {
  return await axios.put<WPSWorks>(`/v1/mgmt/wps/work-items/${id}`, { ...elements })
}

export const reqDeleteWPSWorks = async (id: string) => {
  return await axios.delete(`/v1/mgmt/wps/work-items/${id}`)
}

export const reqCancelWPSWorks = async (id: string) => {
  return await axios.post(`/v1/mgmt/wps/work-items:cancel`, { id })
}
